import R from 'ramda';
import * as steps from 'common/steps';
import * as submissionActions from './submissionActions';

const initialState = {
  loading: true,
  activeStep: steps.INTRODUCTION,
  cancelSubmissionDialogVisible: false,
  invalidSubmissionDialogVisible: false,
  submissionErrorDialogVisible: false,
  validationErrorsDialogVisible: false,
  uploadDialogVisible: false,
  uploadProgress: 0,
  uploadComplete: false,
};

const loadingLens = R.lensProp('loading');
const setLoading = R.set(loadingLens);
export const getLoading = R.view(loadingLens);

const cancelSubmissionDialogVisibleLens = R.lensProp(
  'cancelSubmissionDialogVisible',
);
const setCancelSubmissionDialogVisible = R.set(
  cancelSubmissionDialogVisibleLens,
);
export const getCancelSubmissionDialogVisible = R.view(
  cancelSubmissionDialogVisibleLens,
);

const invalidSubmissionDialogVisibleLens = R.lensProp(
  'invalidSubmissionDialogVisible',
);
const setInvalidSubmissionDialogVisible = R.set(
  invalidSubmissionDialogVisibleLens,
);
export const getInvalidSubmissionDialogVisible = R.view(
  invalidSubmissionDialogVisibleLens,
);

const validationErrorsDialogVisibleLens = R.lensProp(
  'validationErrorsDialogVisible',
);
const setValidationErrorsDialogVisible = R.set(
  validationErrorsDialogVisibleLens,
);
export const getValidationErrorsDialogVisible = R.view(
  validationErrorsDialogVisibleLens,
);

const submissionErrorDialogVisibleLens = R.lensProp(
  'submissionErrorDialogVisible',
);
const setSubmissionErrorDialogVisible = R.set(submissionErrorDialogVisibleLens);
export const getSubmissionErrorDialogVisible = R.view(
  submissionErrorDialogVisibleLens,
);

const uploadDialogVisibleLens = R.lensProp('uploadDialogVisible');
const setUploadDialogVisible = R.set(uploadDialogVisibleLens);
export const getUploadDialogVisible = R.view(uploadDialogVisibleLens);

const uploadCompleteLens = R.lensProp('uploadComplete');
const setUploadComplete = R.set(uploadCompleteLens);
export const getUploadComplete = R.view(uploadCompleteLens);

const uploadProgressLens = R.lensProp('uploadProgress');
const setUploadProgress = R.set(uploadProgressLens);
export const getUploadProgress = R.view(uploadProgressLens);

const activeStepLens = R.lensProp('activeStep');
const setActiveStep = R.set(activeStepLens);
export const getActiveStep = R.view(activeStepLens);
export const isActiveStep = R.curry(
  (step, state) => getActiveStep(state) === step,
);

const cancelSubmission = R.pipe(
  setUploadDialogVisible(false),
  setCancelSubmissionDialogVisible(false),
  setActiveStep(initialState.activeStep),
);

const cancelUpload = R.pipe(
  setUploadDialogVisible(false),
  setUploadComplete(false),
  setUploadProgress(0),
);

const invalidSubmission = (firstInvalidStep, state) =>
  R.pipe(
    setActiveStep(firstInvalidStep),
    setInvalidSubmissionDialogVisible(true),
  )(state);

const localStorageLoaded = (data, state) =>
  R.pipe(
    setLoading(false),
    R.unless(() => R.isEmpty(data), setActiveStep(data.activeStep)),
  )(state);

const sendSubmission = setUploadDialogVisible(true);

const submissionError = R.pipe(
  setSubmissionErrorDialogVisible(true),
  cancelUpload,
);

const uploadComplete = R.pipe(setUploadComplete(true), setUploadProgress(0));

const uploadProgress = (progress, state) => setUploadProgress(progress, state);

const submissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case submissionActions.CANCEL_SUBMISSION:
      return cancelSubmission(state);

    case submissionActions.CANCEL_UPLOAD:
      return cancelUpload(state);

    case submissionActions.INVALID_SUBMISSION:
      return invalidSubmission(action.firstInvalidStep, state);

    case submissionActions.LOCAL_STORAGE_LOADED:
      return localStorageLoaded(action.data, state);

    case submissionActions.SEND_SUBMISSION:
      return sendSubmission(state);

    case submissionActions.SET_ACTIVE_STEP:
      return setActiveStep(action.step, state);

    case submissionActions.SHOW_CANCEL_SUBMISSION_DIALOG:
      return setCancelSubmissionDialogVisible(action.show, state);

    case submissionActions.SHOW_INVALID_SUBMISSION_DIALOG:
      return setInvalidSubmissionDialogVisible(action.show, state);

    case submissionActions.SHOW_SUBMISSION_ERROR_DIALOG:
      return setSubmissionErrorDialogVisible(action.show, state);

    case submissionActions.SHOW_VALIDATION_ERRORS_DIALOG:
      return setValidationErrorsDialogVisible(action.show, state);

    case submissionActions.SUBMISSION_ERROR:
      return submissionError(state);

    case submissionActions.UPLOAD_COMPLETE:
      return uploadComplete(state);

    case submissionActions.UPLOAD_PROGRESS:
      return uploadProgress(action.percent, state);

    default:
      return state;
  }
};

export default submissionReducer;



// WEBPACK FOOTER //
// ./src/submission/submissionReducer.js